import React from 'react';
import BaseClass from '@/pages/BaseClass';

import $ from 'jquery';
import {
	Form,
	Button,
	Input,
	Image,
} from 'antd';
import {
	UploadOutlined,
	EyeOutlined,
	DeleteOutlined,
	CheckCircleOutlined,
} from '@ant-design/icons';

import {
	CommonValue,
	pcUrl,
	confirm,
	message,
	notify,
	scanPost
} from '@/utils/Tools';

export default class App extends BaseClass
{
	constructor(props)
	{
		super(props);
		
		this.state={
			'packageId':0,
			'siteId':0,
			'imageList':[],
			'orderInfo':{},
			'typeList':[],
			'preview':{
				'visible':false,
				'src':'',
			},
			'imageWidth':0,
			'event':{
				'startTime':0,
				'endTime':0,
				'timeout':null,
			},
			
			'mode':'preview',
			
		};
	}
	
	componentDidMount()
	{
		document.title = '拍照留存';
		global.setScanState({
			'headScope':{
				'leftButton':(
					<a href="javascript:;" onClick={()=>this.props.history.goBack()}>
						<span className="fa fa-angle-left"></span>
						返回
					</a>
				),
				'title':'拍照留存',
				'rightButton':null,
			},
		});
		
		let id = this.props.match.params.id;
		id = id.split('_');
		this.state.packageId = id[0];
		this.state.siteId = id[1] || 1;
		this.getInfo();
		this.getTypeList();
		
		this.uploadRef.addEventListener('change',e=>{
			//文件上传
			let files = e.target.files;
			if(!files.length) return false;
			
			let thumbNames = [];
			
			for(let i = 0; i<files.length; i++)
			{
				thumbNames[i] = '';
				let rawFile = files[i];
				
				let url = pcUrl('scan','upload');
				let param = new FormData();
				param.append('file',rawFile);
				param.append('package_id',this.state.packageId);
				param.append('site_id',this.state.siteId);
				param.append('thumb_size','300,300');
				if(0 == i)
					param.append('first_file',1);
				
				let imageList = this.state.imageList;
				let file = {
					'uid':imageList.length,
					'name':rawFile.name,
					'status':'uploading',
					'progress':0,
					'url':'',
					'originUrl':'',
				};
				imageList.push(file);
				this.setState({
					imageList,
				});
				
				scanPost(url,param,{
					'onUploadProgress':(event)=>{
						file.progress = Math.round(event.loaded*100 / event.total);
						this.setState({
							'imageList':imageList,
						});
					},
					'loadingNode':(<span className="fa fa-spin fa-spinner" style={{'fontSize':'30px'}}></span>),
				})
					.then(data=>{
						let thumbName = data;
						let imageName = thumbName.replace('.thumb.','.');
						file.status = 'done';
						file.url = thumbName;
						file.originUrl = imageName;
						this.setState({
							'imageList':imageList,
						});
						//thumbNames.push(thumbName);
						thumbNames[i] = thumbName;
						
						//最后的处理
						//if(i == files.length - 1)
						//if(thumbNames.length  == files.length)
						//if(!thumbNames.includes(''))
						if(thumbNames.indexOf('') === -1)
						{
							url = pcUrl('scan','afterUpload');
							param = {
								'package_id':this.state.packageId,
								'site_id':this.state.siteId,
								'thumb_names':thumbNames.join(','),
							};
							scanPost(url,param)
								.then(()=>{
									message('图片上传成功','success');
									e.target.value = null;
								});
						}
					});
			}
			//this.value = null;
		});
		
		//计算图片高度
		let bodyWidth = $('.m-body').width();
		let imageWidth = Math.round((bodyWidth - 5*2)/3);
		this.setState({
			imageWidth,
		});
	}
	
	getInfo()
	{
		let url = pcUrl('scan','albumInfo');
		let param = {
			'package_id':this.state.packageId,
			'site_id':this.state.siteId,
		};
		scanPost(url,param)
			.then(data=>{
				//处理imageList
				let imageList = data.album.map((row,index)=>{
					return {
						'uid':index,
						'name':'',
						'status':'done',
						'url':row['thumb_name'],
						'originUrl':row['image_name'],
					};
				});
				
				this.setState({
					'orderInfo':data,
					'imageList':imageList,
				});
			});
	}
	
	getTypeList()
	{
		let url = pcUrl('index','typeList');
		scanPost(url)
			.then(data=>{
				this.setState({
					'typeList':data['type_list'][0],
				});
			});
	}
	
	uploadClick()
	{
		this.uploadRef.click();
	}
	
	showAlbum(index)
	{
		let image = this.state.imageList[index];
		if(image.status != 'done') return;
		
		let preview = this.state.preview;
		preview.src = image.originUrl;
		preview.visible = true;
		
		this.setState({
			preview,
		});
	}
	
	/*
	deleteAlbum(index)
	{
		let image = this.state.imageList[index];
		if(image.status != 'done') return;
		
		confirm('确认要删除该图片吗?')
		.then(()=>{
			let url = pcUrl('scan','deleteAlbum');
			let param = {
				'order_id':this.state.orderId,
				'site_id':this.state.siteId,
				'thumb_name':image.url,
			};
			scanPost(url,param)
				.then(()=>{
					let imageList = this.state.imageList;
					imageList.splice(index,1);
					this.setState({
						imageList,
					});
				});
		});
	}
	*/
	
	toggleMode()
	{
		//选择图片模式
		if('preview' == this.state.mode)
		{
			this.setState({
				'mode':'delete',
			});
		}
		else if('delete' == this.state.mode)
		{
			let imageList = this.state.imageList;
			imageList.forEach(row=>{
				row.checked = false;
			});
			this.setState({
				'mode':'preview',
				'imageList':imageList,
			});
		}
	}
	
	clickImage(index)
	{
		if(this.state.mode == 'preview')
		{
			this.showAlbum(index);
		}
		else if(this.state.mode == 'delete')
		{
			let imageList = this.state.imageList;
			imageList[index].checked = !imageList[index].checked;
			
			this.setState({
				imageList
			});
		}
	}
	
	deleteAlbum()
	{
		let selection = this.state.imageList.filter(row=>row.checked);
		if(!selection.length)
		{
			message('请选择要删除的图片');
			return false;
		}
		
		confirm('确认要删除选中的图片吗?')
			.then(()=>{
				let url = pcUrl('scan','deleteAlbum');
				let param = {
					'package_id':this.state.packageId,
					'site_id':this.state.siteId,
					'thumb_names':selection.map(row=>row['url']).join(','),
				};
				scanPost(url,param)
					.then(()=>{
						message('图片删除成功','success');
						
						let imageList = this.state.imageList;
						imageList = imageList.filter(row=>!row.checked);
						this.setState({
							imageList,
							'mode':'preview',
						});
					});
			});
	}
	
	albumTouchStart(e,index)
	{
		let event = this.state.event;
		event.startTime = new Date().getTime();
		
		//长按事件
		event.timeout = window.setTimeout(()=>{
			this.deleteAlbum(index);
			event.timeout = null;
		},2000);
		e.stopPropagation();
		e.preventDefault();
	}
	
	albumTouchEnd(e,index)
	{
		let event = this.state.event;
		let now = new Date().getTime();
		
		//点击事件
		if(event.timeout)
		{
			//console.log('点击事件');
			
			window.clearTimeout(event.timeout);
			this.showAlbum(index);
		}
		e.stopPropagation();
		e.preventDefault();
	}
	
	render()
	{
		return (
			<div className="m-scan">
				<div className="m-body">
					<h3>
						拍照留存
					</h3>
					<div className="desc" style={{'marginBottom':'40px'}}>
						订单编号{this.state.orderInfo['order_sn']}，请上传已拍照完成的照片至服务器
					</div>
					<div className="text-right" size="small" style={{'marginBottom':'20px'}}>
						{this.state.mode == 'preview' && (
							<Button type="primary" onClick={()=>this.toggleMode()}>选择图片</Button>
						)}
						{this.state.mode == 'delete' && (
							<>
								<Button type="primary" danger onClick={()=>this.deleteAlbum()}>删除图片</Button>
								&nbsp;
								<Button onClick={()=>this.toggleMode()}>取消</Button>
							</>
						)}
					</div>
					<div className="m-album-list">
						<div className="row gutter">
							
							{this.state.imageList.length > 0 && (
							<>
								{this.state.imageList.map((row,index)=>{
									if(row.status == 'done')
										return (
											<div className="col">
												<div className="m-album" style={{'height':this.state.imageWidth}} onClick={()=>this.clickImage(index)}>
													<img src={row.url} />
													<i style={{'display':this.state.mode == 'delete' ? 'flex':'none'}}>
														{this.state.mode == 'delete' && row.checked && (
															<CheckCircleOutlined />
														)}
													</i>
													{/*
														<i>
															<EyeOutlined onClick={()=>this.showAlbum(index)} />
															<DeleteOutlined onClick={()=>this.deleteAlbum(index)} />
														</i>
													*/}
												</div>
											</div>
										);
									else if(row.status == 'uploading')
										return (
											<div className="col">
												<div className="m-progress-wrapper">
													<div>
														<span className="m-progress">
															<span style={{'width':row.progress +'%'}}></span>
														</span>
														<br />
														上传中
													</div>
												</div>
											</div>
										);
								})}
							</>
							)}
							
							<div className="col">
								<div className="m-upload" onClick={()=>this.uploadClick()} style={{'height':this.state.imageWidth}}>
									{/*
									<Button style={{'width':'8em'}}>
										点击上传
									</Button>
									*/}
									<div>
										<span style={{fontSize:'20px'}}>+</span>
										<br/>
										上传图片
									</div>
								</div>
							</div>
						</div>
						
						<input type="file" multiple accept={this.state.typeList.map(str=>'.'+str).join(',')} ref={e=>this.uploadRef = e} style={{'display':'none'}} />
						<Image preview={{...this.state.preview,'onVisibleChange':val=>{let preview = this.state.preview; preview.visible = val; this.setState({'preview':{...preview}});}}} />
					</div>
				</div>
			</div>
		);
	}
}





